import VIEW_MODE from '../constants/viewMode';
import DEVICE_TYPE from '../constants/deviceType';
var ViewModeWrapper = /** @class */ (function () {
    function ViewModeWrapper() {
        this.setViewMode = this.setViewMode.bind(this);
        this.isSiteMode = this.isSiteMode.bind(this);
        this.isEditMode = this.isEditMode.bind(this);
        this.isPreviewMode = this.isPreviewMode.bind(this);
        this.isSEOMode = this.isSEOMode.bind(this);
        this.isDeviceTypeMobile = this.isDeviceTypeMobile.bind(this);
        this._viewMode = VIEW_MODE.SITE;
    }
    ViewModeWrapper.prototype.setViewMode = function (viewMode) {
        this._viewMode = viewMode;
    };
    ViewModeWrapper.prototype.setDeviceType = function (forceVal) {
        this._deviceType = forceVal;
    };
    ViewModeWrapper.prototype.isSiteMode = function () {
        return this._viewMode === VIEW_MODE.SITE;
    };
    ViewModeWrapper.prototype.isEditMode = function () {
        return this._viewMode === VIEW_MODE.EDIT;
    };
    ViewModeWrapper.prototype.isPreviewMode = function () {
        return this._viewMode === VIEW_MODE.PREVIEW;
    };
    ViewModeWrapper.prototype.isSEOMode = function () {
        return this._viewMode === VIEW_MODE.SEO;
    };
    ViewModeWrapper.prototype.isDeviceTypeMobile = function () {
        return this._deviceType && this._deviceType === DEVICE_TYPE.MOBILE;
    };
    return ViewModeWrapper;
}());
var viewModeWrapper = new ViewModeWrapper();
var isSiteMode = viewModeWrapper.isSiteMode;
var isEditMode = viewModeWrapper.isEditMode;
var isPreviewMode = viewModeWrapper.isPreviewMode;
var isSEOMode = viewModeWrapper.isSEOMode;
var isDeviceTypeMobile = viewModeWrapper.isDeviceTypeMobile;
export { viewModeWrapper, isSiteMode, isEditMode, isPreviewMode, isSEOMode, isDeviceTypeMobile, };
//# sourceMappingURL=viewModeWrapper.js.map